<template>
  <v-app>
    <!-- Nav bar -->
    <v-card class="overflow-hidden">
      <v-app-bar
        absolute
        color="white"
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-btn icon>
          <v-icon>mdi-cheese</v-icon>
        </v-btn>
        <template>
          <v-tabs>
            <v-tab
              :key="item.route"
              :to="item.route"
              v-for="item in navbar_items_active"
            >
              {{ item.text }}
            </v-tab>
          </v-tabs>
        </template>
        <v-spacer></v-spacer>
        <!-- Help/Doc btn -->
        <v-btn class="mx-1" icon @click="ShowHelpDialog()">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>

        <!-- Login btn -->
        <v-btn class="mx-1" icon to="/login">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </v-app-bar>
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto"
        max-height="600"
      >
        <v-container style="height: 60px"> </v-container>
      </v-sheet>
    </v-card>

    <!-- Alert -->
    <v-alert
      v-for="alert in alert_queue"
      :key="alert.message"
      :type="alert.type"
      :value="alert.visible"
      elevation="10"
      transition="fade-transition"
      class="alert"
      prominent
      >{{ alert.message }}</v-alert
    >

    <router-view @ShowAlert="ShowAlert" class="view"> </router-view>

    <!-- Docs Dialog -->
    <v-dialog style="z-index: 15" v-model="docsDialog">
      <v-card><component :is="DialogComponent"></component></v-card>
    </v-dialog>
  </v-app>
</template>

<style scoped>
.view {
  padding: 5%;
  position: absolute;
  width: 100%;
  align-self: center;
  margin-top: 5%;
  z-index: 5;
}

.alert {
  margin: 2% 6%;
  z-index: 10;
  box-shadow: 2;
}
</style>

<script>
import { authApi } from "./auth";
import { dbApi } from "./db";
import DocsDefault from "./Docs/DocsDefault.vue";
import DocsInventory from "./Docs/DocsInventory.vue";
import DocsProducts from "./Docs/DocsProducts.vue";
import DocsMovements from "./Docs/DocsMovements.vue";
import DocsPersons from "./Docs/DocsPersons.vue";
import DocsUsers from "./Docs/DocsUsers.vue";
import DocsLogin from "./Docs/DocsLogin.vue";
import DocsRegisterProducts from "./Docs/DocsRegisterProducts.vue";
import DocsRegisterPeople from "./Docs/DocsRegisterPeople.vue";
import DocsRegisterMovements from "./Docs/DocsRegisterMovements.vue";

export default {
  name: "App",

  data: () => ({
    navbar_items: [
      {
        route: "/inventario",
        text: "Inventario",
        permission_level: "ConsultarInventario",
      },
      {
        route: "/productos",
        text: "Productos",
        permission_level: "ConsultarInventario",
      },
      {
        route: "/movimientos",
        text: "Movimientos",
        permission_level: "ConsultarMovimientos",
      },
      {
        route: "/personas",
        text: "Personas",
        permission_level: "ConsultarPersonas",
      },
      {
        route: "/usuarios",
        text: "Usuarios",
        permission_level: "ConsultarPersonas",
      },
    ],
    navbar_items_active: [],
    alert_queue: [],
    docsDialog: false,
    DialogComponent: null,
  }),

  methods: {
    /**
     * Displays an alert just below the navbar
     * This should be called with the following: this.$emit("ShowAlert", <message>, <alert_type>);
     * @param {Str¡ng} text The message to display
     * @param {String} type The alert type (success, error, warning, etc.)
     */
    ShowAlert(text, type) {
      const new_alert = {
        message: text,
        type: type,
        visible: true,
      };
      this.alert_queue.push(new_alert);
      setTimeout(() => {
        new_alert.visible = false;

        setTimeout(() => {
          this.alert_queue.splice(0, 1);
        }, 1000);
      }, 5000);
    },

    ShowHelpDialog() {
      let path = this.$route.name;
      console.log(path);
      switch (path) {
        case "Inventario":
          this.DialogComponent = DocsInventory;
          break;
        case "Productos":
          this.DialogComponent = DocsProducts;
          break;
        case "Registro Producto":
          this.DialogComponent = DocsRegisterProducts;
          break;
        case "Movimientos":
          this.DialogComponent = DocsMovements;
          break;
        case "Personas":
          this.DialogComponent = DocsPersons;
          break;
        case "Usuarios":
          this.DialogComponent = DocsUsers;
          break;
        case "Login":
          this.DialogComponent = DocsLogin;
          break;
        case "RegistroPersona":
          this.DialogComponent = DocsRegisterPeople;
          break;
        case "RegistroMovimiento":
          this.DialogComponent = DocsRegisterMovements;
          break;

        default:
          this.DialogComponent = DocsDefault;
          break;
      }
      this.docsDialog = true;
    },
  },

  async mounted() {
    dbApi.Setup();
    authApi.auth.onAuthStateChanged((user) => {
      // clear navbar
      this.navbar_items_active = [];
      // refresh navbar items based on role
      dbApi.GetCurrentUserPermissions().then((result) => {
        this.navbar_items.forEach((item) => {
          if (result.includes(item.permission_level)) {
            this.navbar_items_active.push({
              route: item.route,
              text: item.text,
            });
          }
        });
      });
    });
  },
};
</script>
